import _styled from '@emotion/styled/base';
import { Box } from '@mui/material';
import isStyledPropsValid from '../utils/isStyledPropsValid.js';
const StyledWrap = /*#__PURE__*/_styled(Box, {
  shouldForwardProp: isStyledPropsValid,
  target: "e12x1q35"
})(() => ({
  position: 'relative',
  display: 'flex',
  alignItems: 'center',
  '&:hover .avatar-popup': {
    display: 'flex'
  }
}), "");
const StyledAvatar = /*#__PURE__*/_styled("img", {
  target: "e12x1q34"
})("width:20px;height:20px;margin-left:", _ref => {
  let {
    marginLeft
  } = _ref;
  return marginLeft;
}, ";border-radius:50%;" + "");
const StyledName = /*#__PURE__*/_styled("div", {
  target: "e12x1q33"
})({
  name: "m1t5oo",
  styles: "font-size:12px;font-weight:500;margin-left:4px;line-height:20px;color:#222"
});
const StyledLabelContainer = /*#__PURE__*/_styled(Box, {
  shouldForwardProp: isStyledPropsValid,
  target: "e12x1q32"
})(_ref2 => {
  let {
    canClick
  } = _ref2;
  return {
    color: '#7B61FF',
    fontSize: '12px',
    lineHeight: '20px',
    fontWeight: 500,
    position: 'relative',
    marginLeft: '4px',
    cursor: canClick ? 'pointer' : 'default',
    '&:hover >  div': {
      display: 'flex'
    }
  };
}, "");
export { StyledAvatar, StyledLabelContainer, StyledName, StyledWrap };